<app-modal [table]="true" (modalClose)="closeModal()">
    <div class="table">
        <h4 class="table__eyebrow">Table 3</h4>
        <h2 class="table__title">Predictors used in the optimal screening tool</h2>
        <div class="table__list">
            <h3 class="table__subtitle">Variable</h3>
        </div>
        <div class="table__list last-list">
            <ul class="table__column">
                <li class="table__list-item">Smoking quantity (packs of cigarettes per year, n)</li>
                <li class="table__list-item">Pancreatic atrophy (yes/no)</li>
                <li class="table__list-item">Steatorrhea (yes/no)</li>
                <li class="table__list-item">Current alcohol use (yes/no)</li>
                <li class="table__list-item">Serum hemoglobin (g/dL)</li>
                <li class="table__list-item">Serum 25-OH vitamin D (ng/mL)</li>
                <li class="table__list-item">Pancreatic duct contour abnormality (yes/no)</li>
                <li class="table__list-item">Serum albumin (g/dL)</li>
                <li class="table__list-item">Pancreatic parenchymal calcification (yes/no)</li>
                <li class="table__list-item">Use of opiate analgesics (yes/no)</li>
            </ul>
        </div>
    </div>
</app-modal>